import {
  CONSULTAMEDTURNOS_SUCCESS,
  CONSULTAMEDTURNOS_LOADING,
  CONSULTAMEDTURNOS_ERROR,
  CONSULTAMEDTURNOS_LOGOUT,
  RESET_PORTAL_CONTEXT
} from "../ActionTypes";

import consultaMedTurnosInitialState from "../initialStates/consultaMedTurnosInitialState";

const consultaMedTurnos = (state, { payload, type }) => {
  switch (type) {
    case CONSULTAMEDTURNOS_LOADING:
      return {
        ...state,
        consultaMedTurnos: {
          ...state.consultaMedTurnos,
          error: false,
          loading: true,
        },
      };
    case CONSULTAMEDTURNOS_SUCCESS:
      return {
        ...state,
        consultaMedTurnos: {
          ...state.consultaMedTurnos,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case CONSULTAMEDTURNOS_ERROR:
      return {
        ...state,
        consultaMedTurnos: {
          ...state.consultaMedTurnos,
          error: payload,
          loading: false,
        },
      };
    case CONSULTAMEDTURNOS_LOGOUT:
      return consultaMedTurnosInitialState;
    case RESET_PORTAL_CONTEXT:
      return consultaMedTurnosInitialState;

    default:
      return state;
  }
};

export default consultaMedTurnos;
